import React from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import deleteIcon from '../../../assets/images/delete-icon.svg';
import ConfirmModal from '../../../components/ConfirmModal';
import { RouteNameEnum } from '../../../enums/routeName';
import { ServiceNameEnum } from '../../../enums/serviceName';
import useServices from '../../../hooks/useServices';
import { AxiosService } from '../../../utils/axiosService';

interface DeleteFeaturedContentModalProps {
  featuredContentId: number;
  isOpen: boolean;
  handleClose: () => void;
}
const DeleteFeaturedContentModal: React.FC<DeleteFeaturedContentModalProps> = (props) => {
  const { isOpen, handleClose, featuredContentId } = props;
  const navigate = useNavigate();

  const { service: deleteService } = useServices(ServiceNameEnum.featuredContent.delete);

  const deleteFeaturedContent = async (): Promise<void> => {
    const params = { id: featuredContentId };
    const { data, error } = await deleteService.delete({ params });
    if (data) {
      handleClose();
      toast.success('Featured content deleted successfully');
      navigate(RouteNameEnum.featuredContent.index);
    } else if (error) {
      const errorResponse = AxiosService.getErrorResponse(error);
      toast.error(errorResponse?.message);
    }
  };

  return (
    <ConfirmModal
      isOpen={isOpen}
      handleClose={handleClose}
      handleSubmit={deleteFeaturedContent}
      imageUrl={deleteIcon}
      subTitle="Are you sure you want to delete this featured content?"
    />
  );
};

export default DeleteFeaturedContentModal;
